import { QrCodeIcon } from '@fingertip/icons'
import React, { useCallback, useContext } from 'react'

import { RootStoreContext } from '@/lib/stores/root-store'

export const QrTrigger = () => {
  const {
    publicStore: { setDialogBlockId },
  } = useContext(RootStoreContext)

  const handleClick = useCallback(() => {
    setDialogBlockId('QR')
  }, [setDialogBlockId])

  return (
    <button type="button" className="cursor-pointer" onClick={handleClick}>
      <div className="flex items-center gap-2 hover:text-primary transition-colors">
        <QrCodeIcon className="size-4 shrink-0" />
        View QR code
      </div>
    </button>
  )
}
